import SlimSelect from 'slim-select';

export class SlimSelectController {
  private readonly defaultSelector = '.js-slimSelect';
  private selectLabels = document.querySelectorAll('.js-slimSelectLabel');

  constructor(selector?: string, showSearch?: boolean) {
    let slimSelects = document.querySelectorAll(selector || this.defaultSelector);
    slimSelects?.forEach((element: HTMLElement) => {
      this.initSlimSelect(element, showSearch, getSearchLabel());
    });
  }

  initSlimSelect(element: HTMLElement, showSearch?: boolean, searchLabel?: string) {
    const options = element.querySelectorAll('option');
    const select = new SlimSelect({
      select: element,
      showSearch: showSearch || options.length > 10,
      searchPlaceholder: searchLabel,
    });

    // add custom label click functionality for slim selects
    this.selectLabels?.forEach((label: HTMLElement) => {
      if (label.dataset.for === element.dataset.label) {
        label.addEventListener('click', () => {
          select.open();
        });
      }
    });

    /* set default option */
    options.forEach((option) => {
      if (option.dataset.selected === 'true') {
        select.setSelected(option.value);
      }
    });
  }
}

export function getSearchLabel(): string {
  const translationElement = document.querySelector('.js-translations');
  let searchLabel = 'Search';
  if (translationElement instanceof HTMLElement && translationElement.dataset.search) {
    searchLabel = translationElement.dataset.search;
  }
  return searchLabel;
}
